module.exports = __webpack_public_path__ + "img/no_controls.bfc2fa50.svg";